import type { ReactNode } from 'react';

interface FieldProps {
  label: string;
  children: ReactNode;
  htmlFor?: string;
}

/** A stacked label + control.*/
export function Field({ label, children, htmlFor }: FieldProps) {
  return (
    <label htmlFor={htmlFor} className="flex flex-col gap-1.5 text-[13px] font-semibold text-conduril-ink">
      {label}
      {children}
    </label>
  );
}

export const inputClass =
  'rounded-xl border border-conduril-border bg-white px-3.5 py-2.5 text-[15px] font-normal text-conduril-ink ' +
  'placeholder:text-slate-400 min-w-0 shadow-sm transition focus:outline-none focus:border-conduril-light ' +
  'focus:ring-2 focus:ring-conduril-light/25';
